import './AccountRow.scss';

import React from 'react';

import AccountDisplay from 'components/shared/AccountDisplay/AccountDisplay';

import { formatAccountNumber } from 'services/Formats';

const convertAccountToDisplayAccount = (account) => {
  const { owners = [] } = account;
  return {
    ...account,
    accountWChecksum: formatAccountNumber(account),
    owners: owners.map((owner) => owner.ownerName).join(', ')
  };
};

const AccountRow = ({ account, includePending = false }) => {
  return (
    <div
      className="accounts-details-container blocked_data"
      key={account.accountName}>
      <AccountDisplay
        account={convertAccountToDisplayAccount(account)}
        className={'account-details'}
        withLink={false}
        withType={false}
        includePending={includePending}
        withOwners
      />
    </div>
  );
};

export default AccountRow;
